import React from "react";
import { Route, Routes } from "react-router-dom";
import AdminPanelLayout from "./Admin/AdminPanelLayout";
import AdminPanelOperations from "./Admin/AdminPanelOperations";
import AdminPanelUpdateOperations from "./Admin/AdminPanelUpdateOperations";
import AdminPanelList from "./Admin/AdminPanelList";
import AdminPanelHome from "./Admin/AdminPanelHome";
import AdminPanelOrder from "./Admin/AdminPanelOrder";
import { DataProvider } from "./context/DataContext";
import Layout from "./Layout/Layout";
import CategoryDetails from "./components/categories/CategoryDetails";
import CategoryWithImage from "./components/categories/CategoryWithImage";

function App() {
  return (
    <DataProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/:branch" element={<CategoryWithImage />} />
          <Route path="/:branch/:catIndex" element={<CategoryDetails />} />
        </Route>
        <Route path="/admin-panel" element={<AdminPanelLayout />}>
          <Route index element={<AdminPanelHome />} />
          <Route path="/admin-panel/add/:entity" element={<AdminPanelOperations />}/>
          <Route path="/admin-panel/list/:entity" element={<AdminPanelList />}/>
          <Route path="/admin-panel/update/:entity/:id" element={<AdminPanelUpdateOperations />}/>
          <Route path="/admin-panel/order/:entity" element={<AdminPanelOrder />}/>
        </Route>
      </Routes>
    </DataProvider>
  );
}

export default App;
